export default __webpack_public_path__ + "static/media/banner.ca15c12c.svg";